import {
  TRUSTARC_CONTAINER_ID,
  TRUSTARC_GEO_VERIFIED_CLASS as GEO_VERIFIED_CLASS,
  TRUSTARC_US_CLASS
} from '@/utils/trustArc/trustArcDom';

type TrustArcBindMap = {
  region?: string;
  geo?: string;
  country?: string;
};

type TrustArcState = {
  hasRunOnce: boolean;
  intervalId: number | null;
  revealTimeoutId: number | null;
};

const TRUSTARC_STATE: TrustArcState = {
  hasRunOnce: false,
  intervalId: null,
  revealTimeoutId: null
};

const GEO_RESOLUTION_TIMEOUT_MS = 1500;

function stopPolling() {
  if (TRUSTARC_STATE.intervalId !== null) {
    clearInterval(TRUSTARC_STATE.intervalId);
    TRUSTARC_STATE.intervalId = null;
  }
}

function clearRevealTimeout() {
  if (TRUSTARC_STATE.revealTimeoutId !== null) {
    clearTimeout(TRUSTARC_STATE.revealTimeoutId);
    TRUSTARC_STATE.revealTimeoutId = null;
  }
}

function finalizeGeoState(region = '') {
  const container = document.getElementById(TRUSTARC_CONTAINER_ID);

  if (container) {
    if (region === 'US') {
      container.classList.add(TRUSTARC_US_CLASS);
    } else {
      container.classList.remove(TRUSTARC_US_CLASS);
    }

    container.classList.add(GEO_VERIFIED_CLASS);
  }

  TRUSTARC_STATE.hasRunOnce = true;
  stopPolling();
  clearRevealTimeout();
}

function applyUSCustomization() {
  if (TRUSTARC_STATE.hasRunOnce) {
    return;
  }

  const w = window as unknown as {
    truste?: {
      eu?: unknown;
    };
  };

  if (!w.truste || !w.truste.eu) {
    return;
  }

  const eu = w.truste.eu as { bindMap?: TrustArcBindMap };

  if (!eu.bindMap) {
    return;
  }

  const bindMap = eu.bindMap;

  let region = bindMap.region || bindMap.geo || bindMap.country || '';

  region = region.toUpperCase();

  finalizeGeoState(region);
}

export function initTrustArcCustomCSS() {
  if (TRUSTARC_STATE.intervalId !== null || TRUSTARC_STATE.hasRunOnce) {
    return;
  }

  TRUSTARC_STATE.revealTimeoutId = window.setTimeout(() => {
    if (!TRUSTARC_STATE.hasRunOnce) {
      finalizeGeoState();
    }
  }, GEO_RESOLUTION_TIMEOUT_MS);

  TRUSTARC_STATE.intervalId = window.setInterval(applyUSCustomization, 20);
}
